<template>
    <div>
        <!-- Header -->
        <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
            <div class="container">
                <div class="header-body text-center mb-4">
                    <div class="row justify-content-center">
                        <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                            <h1 class="text-white">Forgot password</h1>
                            <p class="text-lead text-white">Better to be safe than sorry.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-7">
                    <div class="card card-profile bg-secondary mt-5">
                        <div class="card-body pt-5 px-5">
                            <div class="text-center mb-4">
                                <h3>{{ $t('auth.requestNewPassword') }}</h3>
                            </div>
                            <form role="form">
                                <base-input
                                    prepend-icon="ni ni-email-83"
                                    type="email"
                                    :placeholder="$t('auth.emailAddress')"
                                    v-model="email"
                                    autofocus
                                    @keydown.enter="requestPassword"></base-input>
                                <div v-if="showFailedMessage" class="failed-message text-danger">
                                    {{ $t('auth.emailNotFound') }}
                                </div>
                                <div class="text-center">
                                    <base-button
                                        type="primary"
                                        class="mt-2"
                                        :loading="requestingPassword"
                                        @click="requestPassword">
                                        {{ requestingPassword ? $t('auth.sending') : $t('auth.send') }}
                                    </base-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'ForgotPassword',
        data() {
            return {
                email: '',
                userValidations: {
                    email: {
                        required: true,
                        email: true
                    },
                },
                requestingPassword: false,
                //showSuccessMessage: false,
                showFailedMessage: false,
            }
        },
        methods: {
            async requestPassword() {
                const formIsValid = await this.$validator.validateAll();

                if (formIsValid) {
                    this.requestingPassword = true;
                    this.$axios.post('/api/password/create', {email: this.email})
                        .then(() => {
                            //this.showSuccessMessage = true;
                            sessionStorage.setItem('forgotPasswordEmailSent', '1');
                            this.$router.push('/login');
                        })
                        .catch(() => {
                            this.showFailedMessage = true;
                        })
                        .then(() => {
                            this.requestingPassword = false;
                        })
                }
            }
        },
    };
</script>

<style lang="scss">
    .failed-message {
        font-size: 13px;
        margin-top: -20px;
        margin-bottom: 20px;
    }
</style>
